export const PRODUCT_CODE_PATTERN = /^[A-Z]{2,3}[0-9]{3,4}$/;

export const CODE_DIGITS_PATTERN = /^\d{3,4}$/;

/**
 * 客戶 detail 上已有的 SN 前綴。沒有就不組代碼。
 *
 * @param {object|null|undefined} customer
 * @returns {string[]}
 */
export function listCustomerSnPrefixes(customer) {
  const codes = [
    customer?.snCode2 ?? customer?.snCode_2,
    customer?.snCode3 ?? customer?.snCode_3,
  ]
    .map((value) => String(value ?? '').trim().toUpperCase())
    .filter((value) => /^[A-Z]{2,3}$/.test(value));
  return [...new Set(codes)];
}

/**
 * @param {string} prefix
 * @param {string} digits
 */
export function composeProductCode(prefix, digits) {
  return `${String(prefix ?? '').trim().toUpperCase()}${String(digits ?? '').trim()}`;
}

/**
 * 依客戶現有前綴拆開既有 product_code，供編輯待指定時回填。
 *
 * @param {string} productCode
 * @param {string[]} prefixes
 */
export function splitProductCode(productCode, prefixes = []) {
  const code = String(productCode ?? '').trim().toUpperCase();
  const prefix = prefixes.find((item) => code.startsWith(item) && code.length > item.length);
  if (!prefix) {
    return { prefix: '', digits: '' };
  }
  return { prefix, digits: code.slice(prefix.length) };
}

/**
 * @param {string|null|undefined} customerId
 * @param {object|null|undefined} customer
 */
export function formatCustomerAssignment(customerId, customer) {
  if (!customerId) {
    return '未指定';
  }
  if (!customer) {
    return '已指定';
  }
  const label = [customer.code, customer.name].filter(Boolean).join(' ');
  return label || '已指定';
}
